package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.domain.model.Friend
import fyi.moko.hotpl.domain.service.MutualWishKey
import fyi.moko.hotpl.domain.service.friendWishKeys
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.combine

/**
 * Which friends want to go where, keyed for the mutual-wish match (0-37 stage 2). The Journal
 * card and Detail read this so a place of mine can say "Alice wants to go too".
 *
 * A `fun interface` so screens that don't care (tests, the JS gate) can hand in
 * `{ flowOf(emptyMap()) }` instead of a full social-graph fake.
 */
fun interface ObserveFriendWishes {
    operator fun invoke(): Flow<Map<MutualWishKey, List<Friend>>>
}

/**
 * Live, via [ObserveFriendsSharedPlacesUseCase]: a friend flipping a place to Friends or
 * logging a visit shows up on my Journal card without me doing anything. Degrades to an
 * empty map (chip quietly gone) when the friends stream fails, e.g. offline.
 */
class ObserveFriendWishesUseCase(
    private val observeFriends: ObserveFriendsUseCase,
    private val observeFriendsSharedPlaces: ObserveFriendsSharedPlacesUseCase,
) : ObserveFriendWishes {
    override operator fun invoke(): Flow<Map<MutualWishKey, List<Friend>>> =
        combine(observeFriends(), observeFriendsSharedPlaces()) { friends, shared ->
            friendWishKeys(friends, shared)
        }.catch { e ->
            if (e is CancellationException) throw e
            emit(emptyMap())
        }
}
